import React, {Fragment} from "react";
import clsx from "clsx";

import ActionElementList from "../shared/related_contents/ActionElementList";
import AppButton from "../shared/AppButton";
import EventInfo from "../shared/related_contents/EventInfo";
import IconContainer from "../shared/IconContainer";
import KeyFigureList from "../shared/related_contents/KeyFigureList";
import Thumbnail from "../shared/related_contents/Thumbnail";
import * as pageStyles from "../../styles/internal-page/internal-page.module.scss";
import ProductInfos from "../shared/related_contents/ProductInfos";

const RelatedContent = ({elem, subIndex}) => {
    if (elem.__typename === "CmsPortalComponentWidgetRelatedContentGroup") {
        if (elem.related_contents?.length > 0) {
            return elem.related_contents.map((elem, index) => {
                if (elem?.content?.length > 0) {
                    return elem.content.map((elem, subIndex) => {
                        return (<div key={subIndex} className={pageStyles.relatedContentContainer}>
                            <RelatedContent
                                elem={elem}
                                subIndex={subIndex}
                            />
                        </div>);
                    });
                }
                return <Fragment key={index}/>;
            });
        }
    }

    if (elem.__typename === "CmsPortalComponentWidgetActionElement") {
        return (<div
            key={elem.__typename}
            className={pageStyles.marginBetweenBlocs}
        >
            <AppButton
                onClick={() => typeof window !== `undefined` && window.open(elem.URL, "_blank")}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        typeof window !== `undefined` && window.open(elem.URL, "_blank")
                    }
                }}
                paddingSide={7}
                padding={12}
                minContent
                width={"100%"}
                variant="contained"
                tabIndex="0"
                color={elem.actionColor === "BLACK" ? "primary" : "secondary"}
                rightIcon={<IconContainer icon={elem.icon} color="WHITE" noHover size={25}
                                          svgClassname={pageStyles.actionElementSVG}/>}
                isActionElement={true}
            >
                <p
                    className={clsx(pageStyles.h4Label, pageStyles.noUpperCase, pageStyles.relatedTitleBig)}>
                    {elem.label}
                </p>
            </AppButton>
        </div>);
    }
    if (elem.__typename === "CmsPortalComponentWidgetThumbnail") {
        return (<div
            className={pageStyles.marginBetweenBlocs}
        >
            <Thumbnail
                color={elem.thumbnailColor}
                title={elem.title}
                html={elem.content}
            ></Thumbnail>
        </div>);
    }
    if (elem.__typename === "CmsPortalComponentWidgetActionElementList") {
        return (<div
            className={pageStyles.marginBetweenBlocs}
        >
            <ActionElementList
                color={elem.actionListColor}
                title={elem.title}
                actions={elem.action}
            ></ActionElementList>
        </div>);
    }

    if (elem.__typename === "CmsPortalComponentWidgetKeyFigureList") {
        return (<div
            className={pageStyles.marginBetweenBlocs}
        >
            <KeyFigureList
                color={elem.keyFigureColor}
                title={elem.title}
                figures={elem.figures}
            ></KeyFigureList>
        </div>);
    }

    if (elem.__typename === "CmsPortalComponentWidgetEventInfo") {
        return (<div
            className={pageStyles.marginBetweenBlocs}
        >
            <EventInfo
                color={elem.eventColor}
                title={elem.title}
                event={elem.event}
            ></EventInfo>
        </div>);
    }

    if (elem.__typename === "CmsPortalComponentWidgetProductInfo") {
        return (<div
            className={pageStyles.marginBetweenBlocs}
        >
            <ProductInfos
                relatedContent={elem}
            />
        </div>);
    }

    return <Fragment/>;
};

export default RelatedContent;
